import { Link } from "react-router";
import { useConvexAuth } from "convex/react";
import { TrackButton } from "./track-button";
import { QuickAddMenu } from "./quick-add-menu";
import { UserMenu } from "./user-menu";

export function Header() {
  const { isAuthenticated } = useConvexAuth();

  if (!isAuthenticated) {
    return (
      <header className="fixed top-0 left-0 right-0 z-30 glass-header pt-[env(safe-area-inset-top)]">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3">
          <Link to="/" className="font-semibold tracking-tight text-lg">
            FlexTrack
          </Link>
        </div>
      </header>
    );
  }

  return (
    <header className="fixed top-0 left-0 right-0 z-30 glass-header pt-[env(safe-area-inset-top)]">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3">
        <UserMenu />

        {/* Desktop navigation - hidden on mobile */}
        <nav className="hidden items-center gap-4 sm:flex">
          <Link to="/blocks" className="text-sm font-medium hover:underline">
            Blocks
          </Link>
          <Link to="/expenses" className="text-sm font-medium hover:underline">
            Expenses
          </Link>
        </nav>

        <div className="flex items-center gap-3">
          <TrackButton />
          <QuickAddMenu />
        </div>
      </div>
    </header>
  );
}
